import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { Label3D } from './Component';
nodeComponentRegistry.register({ typeName: 'Label3D', Component: Label3D });
//# sourceMappingURL=index.r3f.js.map